var $2a03621e773f1678$exports = {};
$2a03621e773f1678$exports = {
  "ascending": "rosn\u0105co",
  "ascendingSort": function ascendingSort(args) {
    return "posortowano wed\u0142ug kolumny ".concat(args.columnName, " w porz\u0105dku rosn\u0105cym");
  },
  "columnSize": function columnSize(args) {
    return "Liczba pikseli: ".concat(args.value);
  },
  "descending": "malej\u0105co",
  "descendingSort": function descendingSort(args) {
    return "posortowano wed\u0142ug kolumny ".concat(args.columnName, " w porz\u0105dku malej\u0105cym");
  },
  "resizerDescription": "Naci\u015Bnij Enter, aby rozpocz\u0105\u0107 zmienianie rozmiaru",
  "select": "Zaznacz",
  "selectAll": "Zaznacz wszystko",
  "sortable": "kolumna z mo\u017Cliwo\u015Bci\u0105 sortowania"
};
export { $2a03621e773f1678$exports as default };